Vue.component('PharmacySiteIndexComponent', require('./components/PharmacySitesIndexComponent').default);
Vue.component('PharmacySiteGetComponent', require('./components/PharmacySiteFormComponent').default);
Vue.component('PharmacySiteDataTable', require('./components/partials/PharmacySiteDataTable').default);

Vue.component('PharmacySiteMainDetails', require('./components/partials/PharmacySiteMainDetails').default);
Vue.component('PharmacySiteChiefPharmacist', require('./components/partials/PharmacySiteChiefPharmacist').default);
Vue.component('PharmacySiteTechnicianDetails', require('./components/partials/PharmacySiteTechnicianDetails').default);
Vue.component('PharmacySiteOutHours', require('./components/partials/PharmacySiteOutHours').default);
Vue.component('PharmacySiteActions', require('./components/partials/PharmacySiteActions').default);
